import styled from '@emotion/styled'

import { overrideOptional } from '@emico/overrides'

import TableDataCell from './TableDataCell'

const TableHeaderCell = styled(TableDataCell)`
  font-weight: bold;
`

export default overrideOptional(TableHeaderCell)
